import React from "react";
import Footer from "./Footer"; // agar same folder me ho to "./Footer"

function RefundCancellation() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* ===== CONTENT ===== */}
      <div
        style={{
          flex: 1,
          padding: "40px 20px",
          maxWidth: "900px",
          margin: "auto",
          lineHeight: "1.7",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
          Refund & Cancellation Policy
        </h1>

        <p>
          At <strong>KingShop</strong>, we value our customers and strive to
          provide the best shopping experience. Please read our refund and
          cancellation policy carefully.
        </p>

        <h3>1. Order Cancellation</h3>
        <p>
          Customers can cancel their order before it is shipped. Once the order
          is shipped, it cannot be cancelled.
        </p>

        <h3>2. How to Cancel an Order</h3>
        <p>
          To cancel an order, please contact our support team via email or phone
          with your Order ID.
        </p>

        <h3>3. Refund Policy</h3>
        <p>
          Refunds are applicable only in the following cases:
        </p>
        <ul>
          <li>Product received is damaged</li>
          <li>Wrong product delivered</li>
          <li>Product missing in the package</li>
        </ul>

        <h3>4. Refund Process</h3>
        <p>
          Once your refund request is approved, the refund will be processed
          within <strong>5–7 working days</strong> to your original payment
          method.
        </p>

        <h3>5. Non-Refundable Items</h3>
        <p>
          Certain products such as perishable goods, personal care items, or
          customized products are non-refundable.
        </p>

        <h3>6. Replacement Policy</h3>
        <p>
          If eligible, we may offer a replacement instead of a refund based on
          product availability.
        </p>

        <h3>7. Shipping Charges</h3>
        <p>
          Shipping charges are non-refundable unless the return is due to our
          mistake.
        </p>

        <h3>8. Contact Us</h3>
        <p>
          If you have any questions about this policy, please contact us:
        </p>
        <p>
          📧 Email: <strong>kingshoppy.as@gmail.com</strong><br />
          📞 Phone: <strong>+91-8966825777</strong>
        </p>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}

export default RefundCancellation;
